export const KEYS = [
  ['applications_without_bgc', 'bgc_processed', 'rfc_processed'],
  ['bgc_processing', 'waiting_for_review_in_bgc', 'approved_in_bgc', 'reproved_in_bgc'],
  ['rfc_processing', 'waiting_for_review_in_rfc', 'approved_in_rfc', 'reproved_in_rfc'],
]

export const TRANSLATED_KEYS = {
  bgc_processed: 'BGCs Processados',
  applications_without_bgc: 'Aplicações em etapas anteriores ao BGC',
  rfc_processed: 'ACs Processadas',
  approved_in_bgc: 'Aprovados no BGC',
  bgc_processing: 'Processando BGC', 
  reproved_in_bgc: 'Reprovados no BGC',
  approved_in_rfc: 'Aprovados no AC', 
  rfc_processing: 'Processando AC', 
  reproved_in_rfc: 'Reprovados no AC',
  total_applications: 'Total de aplicações',
  waiting_for_review_in_bgc: 'Aguardando revisão manual de BGC',
  waiting_for_review_in_rfc: 'Aguardando revisão manual de AC',
}

